import { useEffect, useState } from 'react';

import { ClientDataChangedDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';

export const useSalesInvoiceClientDataChanged = (
  invoiceId: string | null | undefined,
  refresh?: boolean,
): ClientDataChangedDto | null => {
  const [clientDataChanged, setClientDataChanged] =
    useState<ClientDataChangedDto | null>(null);
  const pok = usePokCore();
  const notifications = useNotifications();

  useEffect(() => {
    if (!invoiceId) {
      setClientDataChanged(null);
      return;
    }
    pok.salesInvoicesGetById
      .checkClientDataChanged(invoiceId)
      .then(result => setClientDataChanged(result))
      .catch(errorResponse => {
        notifications.caughtError(errorResponse);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, refresh]);

  return clientDataChanged;
};
